import { JobPost } from './JobPost';
export default JobPost;

//components
export { JobPostSection } from './JobPostSection';
export { JobPostList } from './JobPostList';

//sections
export { Requirements } from './Requirements';
export { Responsibilities } from './Responsibilities';
export { AboutTheProject } from './AboutTheProject';
export { OurOffer } from './OurOffer';
export { Hero } from './Hero';
export { Contact } from './Contact';
